const ProductOptiesStyle = {};

export default ProductOptiesStyle;
